import React from "react";
import { Link } from "react-router-dom";
import "../styles/Banner.css";

import banner1 from "../assets/banner 1 escritorio.jpg";
import banner2 from "../assets/Banner 2 escritorio.jpg";
import banner3 from "../assets/Banner 3 escritorio.jpg";
import banner4 from "../assets/Banner 4 escritorio.jpg";

import mobile1 from "../assets/Banner 1 movil.jpg";
import mobile2 from "../assets/Banner 2 movil.jpg";
import mobile3 from "../assets/Banner 3 movil.jpg";
import mobile4 from "../assets/Banner 4 movil.jpg";
const handleScrollToBottom = () => {
  window.scrollTo({
    top: document.body.scrollHeight, // Desplaza hasta el final de la página
    behavior: "smooth", // Desplazamiento suave
  });
};
const textosPersonalizados = [
  {
    id: 1,
    texto: "Reservar Hora",
    link: "/reserva",
    icono: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        fill="currentColor"
        className="bi bi-calendar-date"
        viewBox="0 0 16 16"
      >
        <path d="M6.445 11.688V6.354h-.633A13 13 0 0 0 4.5 7.16v.695c.375-.257.969-.62 1.258-.777h.012v4.61zm1.188-1.305c.047.64.594 1.406 1.703 1.406 1.258 0 2-1.066 2-2.871 0-1.934-.781-2.668-1.953-2.668-.926 0-1.797.672-1.797 1.809 0 1.16.824 1.77 1.676 1.77.746 0 1.23-.376 1.383-.79h.027c-.004 1.316-.461 2.164-1.305 2.164-.664 0-1.008-.45-1.05-.82zm2.953-2.317c0 .696-.559 1.18-1.184 1.18-.601 0-1.144-.383-1.144-1.2 0-.823.582-1.21 1.168-1.21.633 0 1.16.398 1.16 1.23" />
        <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z" />
      </svg>
    ),
  },

  {
    id: 2,
    texto: "Presupuesto de cirugía",
    link: "/presupuesto",
    icono: (
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-receipt" viewBox="0 0 16 16">
  <path d="M1.92.506a.5.5 0 0 1 .434.14L3 1.293l.646-.647a.5.5 0 0 1 .708 0L5 1.293l.646-.647a.5.5 0 0 1 .708 0L7 1.293l.646-.647a.5.5 0 0 1 .708 0L9 1.293l.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .801.13l.5 1A.5.5 0 0 1 15 2v12a.5.5 0 0 1-.053.224l-.5 1a.5.5 0 0 1-.8.13L13 14.707l-.646.647a.5.5 0 0 1-.708 0L11 14.707l-.646.647a.5.5 0 0 1-.708 0L9 14.707l-.646.647a.5.5 0 0 1-.708 0L7 14.707l-.646.647a.5.5 0 0 1-.708 0L5 14.707l-.646.647a.5.5 0 0 1-.708 0L3 14.707l-.646.647a.5.5 0 0 1-.801-.13l-.5-1A.5.5 0 0 1 1 14V2a.5.5 0 0 1 .053-.224l.5-1a.5.5 0 0 1 .367-.27m.217 1.338L2 2.118v11.764l.137.274.51-.51a.5.5 0 0 1 .707 0l.646.647.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.509.509.137-.274V2.118l-.137-.274-.51.51a.5.5 0 0 1-.707 0L12 1.707l-.646.647a.5.5 0 0 1-.708 0L10 1.707l-.646.647a.5.5 0 0 1-.708 0L8 1.707l-.646.647a.5.5 0 0 1-.708 0L6 1.707l-.646.647a.5.5 0 0 1-.708 0L4 1.707l-.646.647a.5.5 0 0 1-.708 0z"/>
  <path d="M3 4.5a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5m8-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5"/>
</svg>
    ),
  },
  

{
  id: 3,
  texto: "Agendar Ecografías",
  link: "/reserva/ecografia",
  icono: (
    <svg
      id="Capa_2"
      data-name="Capa 2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 74.02 67.07"
      width="32"
      height="32"
      fill="#00afaa"
    >
      <g id="Capa_1-2" data-name="Capa 1">
        <g>
          <path d="M74.02,4.63v29.93c-.48,2.18-2.06,4.11-4.3,4.59-.15.03-1.04.18-1.12.18h-18.87v2.46h6.72c.07,0,1.16.61,1.3.72,1.13.89,1.32,2.57,1.23,3.9h12.35c1.41.36,2.17,1.3,2.68,2.6v6.07c-.56,1.58-1.52,2.57-3.25,2.75H24.13c.18,3.76-2.49,7.46-6,8.68-5.94,2.07-11.79-1.88-12.37-8.02v-15.89c-1.17-.51-2.08-1.5-2.27-2.81-.42-2.9.29-6.47-.11-9.44-.18-.72-.93-.8-1.51-1.24-3.06-2.34-2.25-6.98,1.46-8.06,1.4-.41,5.36-.39,6.8-.06,3.5.81,4.84,5.09,2.27,7.68-.55.55-1.9,1.04-2.09,1.67l-.1,9.59c-.27,1.26-1.13,2.15-2.28,2.66v15.6c.82,9.09,13.79,8.78,14.02-.36-1.4-.07-2.7-.9-3.2-2.22-.45-1.19-.42-6.04.06-7.23.39-.96,1.48-1.83,2.51-1.97,2.71-.37,6.16.24,8.94,0,1.14.18,1.21,1.93-.29,2.15-2.49.35-5.76-.32-8.24,0-.51.07-.99.6-1.07,1.1-.14.87-.11,3.7,0,4.62.08.73.36,1.2,1.12,1.34l48.7.04c.64.04,1.26-.48,1.36-1.1.14-.9.12-3.96.01-4.91-.07-.64-.43-1.04-1.08-1.08h-11.79c.28,2.23-.79,4.27-3.12,4.61-6.1-.33-12.75.49-18.79.02-1.53-.12-2.89-.92-3.33-2.46-.34-1.2-.36-5.48,0-6.66,1.11-3.55,5.91-1.98,8.69-2.3.21-.02.37-.02.5-.22v-2.24h-19.01c-2.69,0-5.3-2.6-5.42-5.28V5.29c.26-2.91,2.36-5.02,5.27-5.29h45.12c2.67.25,4.49,2.1,5.14,4.63ZM23.52,2.21c-1.67.28-2.75,1.7-2.86,3.36v28.06c.18,2.25,1.48,3.37,3.69,3.54h43.82c1.93-.05,3.51-1.28,3.69-3.25V5.42c-.16-1.86-1.4-3.09-3.25-3.25l-45.08.04Z" />
        </g>
      </g>
    </svg>
  ),
},
{
  id: 4,
  texto: "Examenes Cardiología",
  link: "/especialidad/cardiologia",
  icono: (
    <svg
      id="Capa_2"
      data-name="Capa 2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 70.1 77.46"
      width="32"
      height="32"
      fill="#00afaa"
    >
      <defs>
        <style>
          {`.cls-1 { fill: #00afaa; }`}
        </style>
      </defs>
      <g id="Capa_1-2" data-name="Capa 1">
        <g>
          <path className="cls-1" d="M26.48.04c3.34.38,7.41,3.98,7.41,7.48v2.19h13.69c1.66.19,2.92,1.5,3.24,3.11l.08,11.41c1.47.21,2.92.39,4.35.79,19.72,5.47,19.83,33.85.12,39.49-1.47.42-2.96.61-4.47.82l-.13,9.24c-.4,1.58-1.81,2.83-3.48,2.87H3.26c-1.72-.24-3.11-1.66-3.26-3.4L.04,12.7c.34-1.52,1.55-2.69,3.08-2.97h13.83v-2.21C16.95,4.03,21.03.42,24.36.04c.52-.06,1.6-.06,2.12,0ZM31.47,9.72C32.23.11,18.61.11,19.37,9.72h2.42c-.72-6.41,7.99-6.43,7.26,0h2.42ZM26.63,9.72c.58-3.28-3-3.28-2.42,0h2.42ZM12.11,12.14H3.26c-.35,0-.98.87-.84,1.28v60.34c-.02.51.21.93.65,1.16l44.06.12c.64.03,1.17-.35,1.27-1l-.06-8.69c-1.22-.19-2.43-.32-3.63-.61-20.34-4.85-20.91-34.05-.72-39.71,1.44-.4,2.88-.58,4.35-.79l.07-10.97c.09-.37-.55-1.13-.84-1.13h-8.85v4.01c0,.35-.87.98-1.28.84H13.24c-.37.09-1.13-.55-1.13-.84v-4.01ZM36.31,12.14H14.53v2.42h21.78v-2.42ZM67.77,44.79c0-10.02-8.12-18.14-18.15-18.14s-18.15,8.12-18.15,18.14,8.12,18.14,18.15,18.14,18.15-8.12,18.15-18.14Z" />
          <path className="cls-1" d="M42.32,33.19c2.76-.35,5.31.55,7.24,2.52,1.54-1.23,3.08-2.36,5.12-2.56,7.6-.75,11.82,7.75,6.89,13.53-3.26,3.82-7.68,7.23-11.04,11.04-.5.52-1.32.52-1.82,0-3.36-3.8-7.78-7.21-11.04-11.04-4.15-4.86-1.8-12.68,4.66-13.5ZM42.63,35.61c-4.35.6-6.06,5.91-3.29,9.26,2.84,3.45,7.03,6.54,9.98,9.98l.36.21,10.51-10.52c3.83-5.34-2.84-11.84-8.06-7.76-.75.58-1.58,2.01-2.57,1.97-.86-.04-1.75-1.44-2.43-1.97-1.3-1.02-2.85-1.4-4.5-1.17Z" />
        </g>
      </g>
    </svg>
  ),
},

];

const Banner = () => {
  return (
    <div className="container">
      <div className="row">
        <div className="col-12 pt-4">
          {/* Carrusel escritorio */}
          <div id="carouselDesktop" className="carousel slide desktop-carousel" data-bs-ride="carousel">
            <div className="carousel-indicators">
              {[0, 1, 2, 3].map((i) => (
                <button key={i} type="button" data-bs-target="#carouselDesktop" data-bs-slide-to={i} className={i === 0 ? "active" : ""} />
              ))}
            </div>
            <div className="carousel-inner">
              {[banner1, banner2, banner3, banner4].map((img, idx) => (
                <div className={`carousel-item ${idx === 0 ? "active" : ""}`} key={idx}>
                  <Link to={["/reserva", "/especialidad/dermatologia", "/especialidad/cardiologia", "/promocion-4"][idx]}>
                    <img src={img} className="d-block w-100" alt={`Escritorio ${idx + 1}`} />
                  </Link>
                </div>
              ))}
            </div>
            <button className="carousel-control-prev" type="button" data-bs-target="#carouselDesktop" data-bs-slide="prev">
              <span className="carousel-control-prev-icon" />
            </button>
            <button className="carousel-control-next" type="button" data-bs-target="#carouselDesktop" data-bs-slide="next">
              <span className="carousel-control-next-icon" />
            </button>
          </div>
        </div>
      </div>

      {/* Carrusel móvil */}
      <div id="carouselMobile" className="carousel slide mobile-carousel" data-bs-ride="carousel">
        <div className="carousel-inner">
          {[mobile1, mobile2, mobile3, mobile4].map((img, idx) => (
            <div className={`carousel-item ${idx === 0 ? "active" : ""}`} key={idx}>
              <Link to={["/reserva", "/especialidad/1", "/promo-mobile-3", "/promo-mobile-3"][idx]}>
                <img src={img} className="d-block w-100" alt={`Móvil ${idx + 1}`} />
              </Link>
            </div>
          ))}
        </div>
        <button className="carousel-control-prev" type="button" data-bs-target="#carouselMobile" data-bs-slide="prev">
          <span className="carousel-control-prev-icon" />
        </button>
        <button className="carousel-control-next" type="button" data-bs-target="#carouselMobile" data-bs-slide="next">
          <span className="carousel-control-next-icon" />
        </button>
      </div>

      {/* Botones destacados */}
      <div className="container my-5">
        <div className="especialidades-carousel">
          <div className="carousel-track">
            {textosPersonalizados.map(({ id, texto, link, icono }) => (
              <Link key={id} to={link} className="especialidad-card">
                <div className="especialidad-icono">{icono}</div>
                <p className="especialidad-titulo">{texto}</p>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;